import $ from 'jquery';
import { AUTH_KEY, APIBASE } from '~/constant';

let connection = null;
let hubProxy = null;
let conectado = false;
let signalRCarregado = false;

const carregarSignalR = () =>
  new Promise((resolve, reject) => {
    if (signalRCarregado) return resolve();
    window.jQuery = $;
    window.$ = $;
    const script = document.createElement('script');
    script.src = '/jquery.signalR-2.4.3.min.js';
    script.onload = () => {
      signalRCarregado = true;
      resolve();
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });

export const conectar = async (callbacks) => {
  if (conectado) return;

  try {
    await carregarSignalR();
  } catch (err) {
    console.error('SignalR PainelLancamento: erro ao carregar script', err);
    return;
  }

  connection = $.hubConnection(APIBASE, { useDefaultPath: true });

  const token = localStorage.getItem(AUTH_KEY);
  var qs = { env: window.location.hostname === 'localhost' || window.location.hostname.includes('hml') ? 'hml' : 'prod' };
  if (token) {
    qs.bearer_token = token;
  }
  connection.qs = qs;

  hubProxy = connection.createHubProxy('PainelLancamentoHub');

  Object.keys(callbacks).forEach((evento) => {
    hubProxy.on(evento, callbacks[evento]);
  });

  connection
    .start({ transport: ['longPolling', 'serverSentEvents', 'foreverFrame'] })
    .done(() => {
      conectado = true;
      console.log('SignalR PainelLancamento: conectado');
    })
    .fail((err) => {
      console.error('SignalR PainelLancamento: erro ao conectar', err);
    });
};

export const desconectar = () => {
  if (connection && conectado) {
    connection.stop();
    conectado = false;
    connection = null;
    hubProxy = null;
  }
};

export const isConectado = () => conectado;
